/*
 * AI search panel (snippets/ai-search-panel.liquid). Takes over the header search
 * icon: opens at the top of the page on desktop and full screen on phones. Before
 * the shopper types: most asked questions, popular searches, a rotating 5-star
 * review, the latest article and featured products. While typing: AI-ranked
 * products (the store's own card, sold-out dropped), reviews that mention the
 * search, articles, suggestions and a button to the matching collection.
 * Falls back to Shopify predictive search when the AI service is unavailable; if
 * this script never runs, the theme's own search drawer keeps working.
 */
(function () {
  var C = window.AISearchClient, U = window.AISearchPanelUtil;
  var root = document.querySelector('[data-ais]');
  var D = C && C.panelData && C.panelData();
  if (!C || !U || !C.ready() || !C.cfg.ui || !root || !D) return;

  var L = D.labels, N = D.counts, R = D.reviews, esc = U.esc;
  var SURFACE = 'header';
  var input = root.querySelector('[data-ais-input]');
  var form = root.querySelector('[data-ais-form]');
  var body = root.querySelector('[data-ais-body]');
  var featured = ((root.querySelector('[data-ais-featured]') || {}).innerHTML || '').trim();
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var s = { term: '', answer: '', seq: 0, ctrl: null, opener: null, rv: 0, rotate: null, debounce: null, type: null,
    popular: (D.popular || []).slice(0, N.popular), trendingLoaded: false, loved: null, lovedSeq: 0 };

  function section(label, content, link) {
    return '<div class="ais-sec"><div class="ais-lbl"><span>' + esc(label) + '</span>' + (link || '') + '</div>' + content + '</div>';
  }

  function stars(n) {
    return '<span class="ais-stars" aria-label="' + n + ' / 5">' + new Array((n || 5) + 1).join('★') + '</span>';
  }

  function reviewCard(r, i, term, kind) {
    var p = r.product || {};
    return '<a class="ais-rv ais-rv--' + kind + '" href="' + esc(p.url) + '"' + C.aiAttrs(p.handle, 'review', i + 1, SURFACE) + '>' +
      (kind === 'featured' && p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '') +
      '<span class="ais-rv__c">' + stars(r.rating) +
      (kind === 'featured' && r.title ? '<span class="ais-rv__t">' + esc(r.title) + '</span>' : '') +
      '<span class="ais-rv__b">&ldquo;' + U.excerpt(r.body, term, R.excerpt, D.stop) + '&rdquo;</span>' +
      '<span class="ais-rv__m">' + esc(r.reviewer) + (r.verified ? ' · Verified buyer' : '') + ' · <b>' + esc(p.title) + '</b></span></span></a>';
  }

  function destination(term, total) {
    var c = U.collectionFor(term, D);
    return c
      ? { url: c.u, label: U.fill(esc(L.shopCollection), { title: esc(c.t), count: c.n }), short: esc(L.shopShort) }
      : { url: C.cfg.searchUrl + '?q=' + encodeURIComponent(term), label: U.fill(esc(L.seeAll), { count: total, terms: esc(term) }), short: U.fill(esc(L.seeAllShort), { count: total }) };
  }

  // ---- before typing -------------------------------------------------------------

  function lovedHtml() {
    var list = s.loved || [];
    if (!list.length) return '';
    var r = list[s.rv % list.length];
    var dots = list.length > 1 ? '<div class="ais-dots">' + list.map(function (_, i) {
      return '<button type="button" class="' + (i === s.rv % list.length ? 'is-on' : '') + '" data-ais-dot="' + i + '" aria-label="' + (i + 1) + '"></button>';
    }).join('') + '</div>' : '';
    return reviewCard(r, s.rv % list.length, '', 'featured') + dots;
  }

  function emptyHtml() {
    var left = '', right = '';
    if (D.questions.length) {
      left += section(L.questions, '<div class="ais-qs">' + D.questions.map(function (q, i) {
        return '<button type="button" class="ais-q" data-ais-question="' + i + '"><span>' + esc(q.q) + '</span><span aria-hidden="true">&rarr;</span></button>';
      }).join('') + '</div>');
    }
    if (s.popular.length) {
      left += section(L.popular, '<div class="ais-chips">' + s.popular.map(function (t) {
        return '<button type="button" class="ais-chip" data-ais-term="' + esc(t) + '">' + esc(t) + '</button>';
      }).join('') + '</div>');
    }
    right += '<div data-ais-loved>' + ((s.loved || []).length ? section(L.loved, lovedHtml()) : '') + '</div>';
    if (D.latest) {
      right += section(L.blog, '<a class="ais-blog" href="' + esc(D.latest.url) + '"' + C.aiAttrs(D.latest.url, 'article', 1, SURFACE) + '>' +
        (D.latest.image ? '<img src="' + esc(D.latest.image) + '" alt="" loading="lazy">' : '') +
        '<span><span class="ais-blog__t">' + esc(D.latest.title) + '</span><span class="ais-blog__r">' + esc(L.read) + ' &rarr;</span></span></a>',
        D.blogUrl ? '<a href="' + esc(D.blogUrl) + '">' + esc(L.blogAll) + '</a>' : '');
    }
    var html = '<div class="ais-empty"><div>' + left + '</div><div>' + right + '</div></div>';
    if (featured) {
      html += section(L.featured, '<div class="ais-row">' + featured + '</div>',
        D.featuredUrl ? '<a href="' + esc(D.featuredUrl) + '">' + esc(L.featuredAll) + '</a>' : '');
    }
    return html;
  }

  function paintLoved() {
    var box = body.querySelector('[data-ais-loved]');
    if (box) box.innerHTML = (s.loved || []).length ? section(L.loved, lovedHtml()) : '';
  }

  function loadLoved() {
    if (s.loved || !R.featured) return;
    C.reviewsHighlights(R.featured).then(function (list) {
      s.loved = (list || []).filter(function (r) { return r.product && r.product.image && (r.body || '').length >= R.excerpt / 3; });
      if (!s.term && !root.hidden) paintLoved();
    });
  }

  function startRotate() {
    stopRotate();
    if (R.rotate > 0 && !reduceMotion) s.rotate = setInterval(function () { s.rv++; paintLoved(); }, R.rotate * 1000);
  }
  function stopRotate() { clearInterval(s.rotate); s.rotate = null; }

  // Most searched terms of the month that pass a quality gate (enough searches, and
  // the search still finds products), topped up from the setting. Kept per session.
  function loadPopular() {
    if (s.trendingLoaded) return;
    s.trendingLoaded = true;
    var key = 'ais-popular:' + N.popular + ':' + N.popularMin;
    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) {}
    var verified = cached ? Promise.resolve(cached) : C.trending(N.popular * 2, true).then(function (top) {
      var terms = top.filter(function (q) { return q.count >= N.popularMin; }).map(function (q) { return q.query; });
      return Promise.all(terms.map(function (t) {
        return C.query(t).then(function (d) { return d && d.products && d.products.length ? t : null; }, function () { return null; });
      })).then(function (ok) {
        ok = ok.filter(Boolean);
        try { sessionStorage.setItem(key, JSON.stringify(ok)); } catch (e) {}
        return ok;
      });
    });
    verified.then(function (top) {
      var seen = {}, merged = [];
      top.concat(D.popular || []).forEach(function (t) {
        var k = String(t || '').toLowerCase().trim();
        if (k && !seen[k]) { seen[k] = 1; merged.push(t); }
      });
      s.popular = merged.slice(0, N.popular);
      if (!s.term && !root.hidden) render();
    });
  }

  // ---- while typing --------------------------------------------------------------

  // Shopify's own predictive search, shaped like the AI service response.
  function nativeSearch(term, signal) {
    var url = C.cfg.predictiveUrl + '.json?q=' + encodeURIComponent(term) +
      '&resources[type]=product,article&resources[limit]=' + Math.max(N.products, N.articles, 1);
    return fetch(url, { signal: signal }).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
      var res = (d && d.resources && d.resources.results) || {};
      return {
        products: (res.products || []).map(function (p) { return { slug: p.handle, url: p.url, title: p.title, image: p.image, price: p.price }; }),
        articles: (res.articles || []).map(function (a) { return { slug: a.handle, url: a.url, title: a.title }; }),
      };
    });
  }

  function paintReviews(term, handles, seq) {
    if (!R.count) return;
    C.reviewsHighlights(R.count, handles, term).then(function (list) {
      var box = body.querySelector('[data-ais-revs]');
      if (seq !== s.seq || !box || !list || !list.length) return;
      box.innerHTML = section(L.shoppers, list.map(function (r, i) { return reviewCard(r, i, term, 'match'); }).join(''));
    });
  }

  function resultsHtml(term, data, cards, exact) {
    var dest = destination(term, cards.count);
    var sugg = U.suggestions(term, data.didYouMean, s.popular, D.questions.map(function (q) { return q.t; }), N.suggestions);
    var articles = (data.articles || []).slice(0, N.articles);
    var main = s.answer ? '<div class="ais-answer">' + esc(s.answer) + '</div>' : '';
    if (!exact) main += '<p class="ais-none">' + U.fill(esc(L.noMatch), { terms: esc(term) }) + '</p>';
    if (cards.count) {
      main += section(L.products, '<div class="ais-grid">' + cards.html + '</div>', '<a href="' + esc(dest.url) + '">' + dest.short + '</a>') +
        '<a class="ais-all button" href="' + esc(dest.url) + '">' + dest.label + '</a>';
    } else if (featured) {
      main += '<div class="ais-grid">' + featured + '</div>';
    }
    return '<div class="ais-res">' +
      '<div class="ais-res__main">' + main + '</div>' +
      '<div class="ais-res__sugg">' + (sugg.length ? section(L.suggestions, sugg.map(function (x) {
        return '<button type="button" class="ais-sug" data-ais-term="' + esc(x) + '">' + U.highlight(x, term) + '</button>';
      }).join('')) : '') + '</div>' +
      '<div class="ais-res__revs" data-ais-revs></div>' +
      '<div class="ais-res__arts">' + (articles.length ? section(L.articles, '<div class="ais-arts">' + articles.map(function (a, i) {
        return '<a class="ais-art" href="' + esc(a.url) + '"' + C.aiAttrs(a.slug, 'article', cards.count + i + 1, SURFACE) + '>' + esc(a.title) + '</a>';
      }).join('') + '</div>') : '') + '</div>' +
      '</div>';
  }

  function search(term) {
    var seq = ++s.seq;
    if (s.ctrl) s.ctrl.abort();
    s.ctrl = window.AbortController ? new AbortController() : null;
    var signal = s.ctrl && s.ctrl.signal;
    root.classList.add('is-loading');
    C.query(term, { signal: signal })
      .then(function (data) { return data || nativeSearch(term, signal); })
      .then(function (data) {
        data = data || { products: [], articles: [] };
        // No direct match: the service's nearest products stand in, flagged as such.
        var exact = (data.products || []).length > 0;
        var products = exact ? data.products : (data.suggestions || []);
        var handles = products.map(function (p) { return p.slug; });
        return C.renderProducts(products.slice(0, N.products), 'ai-card', SURFACE).then(function (cards) {
          if (seq !== s.seq) return;
          body.innerHTML = resultsHtml(term, data, cards, exact);
          paintReviews(term, handles.slice(0, 3), seq);
          try { if (window.AISearchAnalytics) window.AISearchAnalytics.logSearch(term, exact ? cards.count : 0, SURFACE); } catch (e) {}
        });
      })
      .catch(function () {})
      .then(function () { if (seq === s.seq) root.classList.remove('is-loading'); });
  }

  function render() {
    root.classList.toggle('has-term', !!input.value);
    if (s.term.trim()) { search(s.term.trim()); return; }
    s.seq++;
    root.classList.remove('is-loading');
    body.innerHTML = emptyHtml();
  }

  function setTerm(term, answer) {
    s.term = term;
    s.answer = answer || '';
    render();
  }

  function typeIn(text, term, answer) {
    clearInterval(s.type);
    if (!N.typeMs || reduceMotion) { input.value = text; setTerm(term, answer); return; }
    var i = 0;
    input.value = '';
    s.type = setInterval(function () {
      input.value = text.slice(0, ++i);
      if (i >= text.length) { clearInterval(s.type); setTerm(term, answer); }
    }, N.typeMs);
  }

  // ---- open / close --------------------------------------------------------------

  // Desktop: the bar sits over the theme header, with the header's own logo.
  function placeBar() {
    var header = document.querySelector('.header-wrapper') || document.querySelector('header.header');
    var rect = header && header.getBoundingClientRect();
    root.style.setProperty('--ais-top', Math.max(0, rect ? rect.top : 0) + 'px');
    if (rect && rect.height) root.style.setProperty('--ais-bar', rect.height + 'px');
    var slot = root.querySelector('[data-ais-logo]');
    var logo = header && header.querySelector('.header__heading-link');
    if (slot && logo && !slot.childNodes.length) {
      Array.prototype.forEach.call(logo.childNodes, function (n) { slot.appendChild(n.cloneNode(true)); });
    }
  }

  function open(opener) {
    if (!root.hidden) return;
    s.opener = opener || null;
    placeBar();
    root.hidden = false;
    document.documentElement.classList.add('ais-open');
    if (!input.value) s.term = s.answer = '';
    render();
    startRotate();
    loadPopular();
    loadLoved();
    setTimeout(function () { input.focus(); }, 0);
  }

  function close() {
    if (root.hidden) return;
    root.hidden = true;
    document.documentElement.classList.remove('ais-open');
    stopRotate();
    clearInterval(s.type);
    if (s.opener && s.opener.focus) s.opener.focus();
  }

  // ---- events --------------------------------------------------------------------

  // The header search icon (Dawn's <details-modal> summary) opens the panel instead
  // of the drawer. Capture phase, so the theme's own toggle never runs.
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('.header__icon--search');
    if (!t || root.contains(t)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open(t);
  }, true);

  input.addEventListener('input', function () {
    clearInterval(s.type);
    clearTimeout(s.debounce);
    root.classList.toggle('has-term', !!input.value);
    s.debounce = setTimeout(function () { setTerm(input.value); }, N.debounceMs);
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var term = (s.term || input.value).trim();
    if (!term) return;
    window.location.href = destination(term, 0).url;
  });

  root.addEventListener('click', function (e) {
    var el = e.target.closest('[data-ais-close],[data-ais-clear],[data-ais-question],[data-ais-term],[data-ais-dot]');
    if (!el) return;
    if (el.hasAttribute('data-ais-close')) { close(); return; }
    if (el.hasAttribute('data-ais-clear')) { clearInterval(s.type); input.value = ''; setTerm(''); input.focus(); return; }
    if (el.hasAttribute('data-ais-dot')) { s.rv = Number(el.getAttribute('data-ais-dot')); paintLoved(); startRotate(); return; }
    if (el.hasAttribute('data-ais-question')) {
      var q = D.questions[Number(el.getAttribute('data-ais-question'))];
      if (q) typeIn(q.q, q.t, q.a);
      return;
    }
    var term = el.getAttribute('data-ais-term');
    typeIn(term, term);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) { e.preventDefault(); close(); }
  });
})();
